const template = document.createElement("template");

template.innerHTML = `
  <span class="modal-item">
    <slot></slot>
    <div class="modal">
        <div class="modal-header">
            <div class="exit-container">
            <div id="exit-button" class="exit-button">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.47972 6.25388C7.14121 5.91537 6.59238 5.91537 6.25388 6.25388C5.91537 6.59238 5.91537 7.14121 6.25388 7.47972L10.7742 12L6.25388 16.5203C5.91537 16.8588 5.91537 17.4076 6.25388 17.7461C6.59238 18.0846 7.14121 18.0846 7.47972 17.7461L12 13.2258L16.5203 17.7461C16.8588 18.0846 17.4076 18.0846 17.7461 17.7461C18.0846 17.4076 18.0846 16.8588 17.7461 16.5203L13.2258 12L17.7461 7.47972C18.0846 7.14121 18.0846 6.59239 17.7461 6.25388C17.4076 5.91537 16.8588 5.91537 16.5203 6.25388L12 10.7742L7.47972 6.25388Z" fill="#162751"/>
                </svg>
            </div>
            </div>
            <div class="modal-header-logo">
                <svg width="33.4" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M34.1976 7.47698L24.6448 0V14.954L34.1976 7.47698Z" fill="#060A2A"/>
                    <path d="M28.936 4.19507H12.8167V10.7825H28.936V4.19507Z" fill="#060A2A"/>
                    <path d="M0.80249 16.523L10.3553 24V9.04602L0.80249 16.523Z" fill="#060A2A"/>
                    <path d="M6.06348 19.8043L22.1829 19.8043V13.2169L6.06348 13.2169V19.8043Z" fill="#060A2A"/>
                </svg>
            </div>
            <div id="modal-header-title" class="modal-header-title"></div>
        </div>
        <div class="modal-content">
            <div class="modal-text-container">
                <h3 id="first-text-h" class="modal-content-h first-text-h"></h3>
                <span id="first-text-span" class="modal-content-span first-text-span"></span>
                <h3 id="second-text-h" class="modal-content-h"></h3>
                <span id="second-text-span" class="modal-content-span"></span>
            </div>
        </div>
    </div>
    <div class="modal-overlay"></div>
  </span>

  <style>
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 10;
        display: none;
        background-color: rgba(0, 20, 60, 0.4);
    }

    .modal {
        display: none;
        position: absolute;
        top: 16px;
        left: 0;
        width: 327px;
        border-radius: 4px;
        border: 1px solid #D7E3FF;
        border-radius: 4px;
        z-index: 100;
        font-family: Verdana;
    }

    .modal-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 12px;
        background: #FFFFFF;
        border-bottom: 1px solid rgba(215, 227, 255, 1);
    }

    .exit-container {
        width: 100%;
        justify-content: end;
        display: flex;
    }

    .exit-button {
        cursor: pointer;
    }

    .modal-header-logo {
        margin-bottom: 14px;
        height: 24px;
    }

    .modal-header-title {
        font-size: 16px;
        font-weight: 700;
    }

    .modal-content {
        background: #F3F7FF;
        padding: 24px;
        text-align: center;
        line-height: 16px;
        letter-spacing: 0.048px;
    }

    .modal-content-h {
        font-size: 12px;
        font-weight: 700;
        margin-bottom: 0;
    }

    .modal-content-h:first-child {
        margin-top: 0;
    }
    
    .modal-content-span {
        font-size: 12px;
        color: #7382a6;
    }
  </style>
`;

class ModalItem extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: "open" });
        shadow.append(template.content.cloneNode(true));

        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }
  
    static get observedAttributes() {
        return ['modal-header-title', 'first-text-h', 'first-text-span', 'second-text-h', 'second-text-span', 'position-container-class'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this.updateModalContent(name, newValue);
            this[name.replace(/-./g, x => x[1].toUpperCase())] = newValue;
        }
    }

    connectedCallback() {
        this.shadowRoot.querySelector('.modal-item').addEventListener('click', this.showModal);
        this.shadowRoot.getElementById('exit-button').addEventListener('click', (e) => this.hideModal(e));
        this.shadowRoot.querySelector('.modal-overlay').addEventListener('click', (e) => this.hideModal(e));
    }

    disconnectedCallback() {
        this.shadowRoot.querySelector('.modal-item').removeEventListener('click', this.showModal);
        this.shadowRoot.getElementById('exit-button').removeEventListener('click', (e) => this.hideModal(e));
        this.shadowRoot.querySelector('.modal-overlay').removeEventListener('click', (e) => this.hideModal(e));
    }

    updateModalContent(id, value) {
        const element = this.shadowRoot.getElementById(`${id}`);
        if (element) {
            element.textContent = value;
        }
    }

    showModal() {
        const modal = this.shadowRoot.querySelector('.modal');
        const overlay = this.shadowRoot.querySelector('.modal-overlay');
        modal.style.display = 'block';
        const classOfContainer = this.positionContainerClass ? this.positionContainerClass : 'byob-content-wrapper';
        const container = document.getElementsByClassName(classOfContainer)[0];
        if (container) {
            const left = (container.offsetWidth - modal.offsetWidth) / 2;
            modal.style.left = `${left}px`;
            overlay.style.height = `${container.scrollHeight}px`;
            overlay.style.width = `${container.clientWidth}px`;
        }
        overlay.style.display = 'block';
    }

    hideModal(e) {
        e.stopPropagation();
        const modal = this.shadowRoot.querySelector('.modal');
        const overlay = this.shadowRoot.querySelector('.modal-overlay');

        modal.style.display = 'none';
        overlay.style.display = 'none';
    }
}

if (!customElements.get('modal-item')) { customElements.define('modal-item', ModalItem); }